import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { Inventory2 } from "@mui/icons-material";
import { Dimension } from "../../types";
import { useTranslation } from "../../../../hooks/useTranslation";
import { SectionHeader } from "../../../../components/ui/SectionHeader";

type Props = {
  dimensions: {
    length?: Dimension;
    width?: Dimension;
    height?: Dimension;
    weight?: Dimension;
  };
  totalDesi?: number;
  estimatedCost?: number;
};

export const PackageInfoCard = ({
  dimensions,
  totalDesi,
  estimatedCost,
}: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  const formatDimensionValue = (dimension?: Dimension) => {
    if (!dimension?.value) return "-";
    return `${dimension.value} ${dimension.unit ?? ""}`.trim();
  };

  const formatDimensions = () => {
    const parts = [
      dimensions.length?.value ? `${dimensions.length.value}` : undefined,
      dimensions.width?.value ? `${dimensions.width.value}` : undefined,
      dimensions.height?.value ? `${dimensions.height.value}` : undefined,
    ].filter(Boolean);

    if (parts.length === 0) return "-";

    return `${parts.join(" x ")}${dimensions.height?.unit ? ` ${dimensions.height.unit}` : ""}`;
  };

  return (
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      <SectionHeader
        icon={<Inventory2 sx={{ fontSize: 20, color: "primary.main" }} />}
        title={translate("packageInfo.title")}
        color="primary"
      />

      <Divider sx={{ my: 2 }} />

      {/* CONTENT – LABEL / VALUE */}
      <Stack spacing={1}>
        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.dimensions")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 400 }}
          >
            {formatDimensions()}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.weight")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 400 }}
          >
            {formatDimensionValue(dimensions.weight)}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.desi")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 400 }}
          >
            {totalDesi ?? "-"}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.warehouseCost")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 400 }}
          >
            {estimatedCost != null ? `${estimatedCost} $` : "-"}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};
